import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import { BsExclamationTriangle } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';
import { BILLING_SETTINGS_PATH } from '#lib/constants/routes';

const CreditsExhaustedModal = ({ isOpen, onClose, needsSubscription }) => {
	const navigate = useNavigate();

	const handleSubscriptionClick = () => {
		navigate(BILLING_SETTINGS_PATH);
		onClose();
	};

	const renewalText = needsSubscription
		? 'Ihre Credits sind aufgebraucht. Um weiterhin alle Features nutzen zu können, wählen Sie bitte ein passendes Abonnement aus.'
		: 'Ihre Credits sind aufgebraucht. Neue Credits stehen Ihnen zum nächsten Abrechnungszeitraum zur Verfügung.';

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="m">
			<Panel.Header icon={BsExclamationTriangle} onClose={onClose}>
				Credits aufgebraucht
			</Panel.Header>
			<Panel.Body>
				<p className="text-sm text-text">{renewalText}</p>
			</Panel.Body>
			<Panel.Footer className="justify-end">
				{needsSubscription ? (
					<>
						<Button variant="outline" onClick={onClose}>
							Später
						</Button>

						<Button variant="solid" onClick={handleSubscriptionClick}>
							Abonnement auswählen
						</Button>
					</>
				) : (
					<Button variant="outline" onClick={onClose}>
						Verstanden
					</Button>
				)}
			</Panel.Footer>
		</Modal>
	);
};

CreditsExhaustedModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	needsSubscription: PropTypes.bool.isRequired,
};

export default CreditsExhaustedModal;
